/** @format */
import React from "react";
import Home from "./Home";
import Presentation from "./Presentation";
import Galeries from "./Galeries.js";
import Download from "./Download.js";

import Contact from "./Contact.js";
export const Main = () => {
  return (
    <div className="w-full min-h-screen">
      {/* Section Home */}
      <Home />
      {/* Section Présentation */}
      <Presentation />

      {/* Section Galeries */}

      <Galeries />
      {/* Section Avis */}

      {/* Section Téléchargements */}
      <Download />

      {/* Section Formulaire */}

      <Contact />
    </div>
  );
};
